import { render, staticRenderFns } from "./ServiceTypeHalfYear.vue?vue&type=template&id=39c02d56&scoped=true"
import script from "./ServiceTypeHalfYear.vue?vue&type=script&lang=js"
export * from "./ServiceTypeHalfYear.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39c02d56",
  null
  
)

export default component.exports